<template>
  <div>
    <ValidationObserver>
      <div class="mb-10 relative">
        <ValidationProvider :rules="{ required: true, regex: /^[a-zA-Z0-9_]{1,32}$/ }" v-slot="{ errors, invalid }">
          <zt-input
            class="zt-input-user"
            ref="ztInputUser"
            :outlined="true"
            name="user"
            :label="loginCustomParamsFields.textLabels.user"
            :style="[loginCustomParamsFields.styles.form.inputs.bgColor]"
            :color="colorOutlineUser(invalid)"
            v-model="value.userName"
            data-vs-input="auth-login-fields-input-user"
          />
          <span class="text-zt-danger absolute left-0" v-show="errors[0]">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
      <div class="mb-4 pb-2 relative">
        <ValidationProvider rules="required|min:4" v-slot="{ errors, invalid }">
          <zt-input
            class="zt-input-password"
            ref="ztInputPass"
            :outlined="true"
            name="password"
            type="password"
            :label="loginCustomParamsFields.textLabels.pass"
            :style="[loginCustomParamsFields.styles.form.inputs.bgColor]"
            v-model="value.userPass"
            @keypress="activeButton"
            data-vs-input="auth-login-fields-input-pass"
          />
        </ValidationProvider>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { localize } from 'vee-validate';

export default {
  name: 'ztAuthLoginFields',
  props: {
    value: {
      type: Object,
      default: () => ({
        userName: '',
        userPass: ''
      })
    },
    loginCustomParamsFields: {
      type: Object,
      default: () => {}
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {}
  },
  created() {
    localize('es')
    localize({
      es: {
        messages: {
          required: this.$t('message.loginComponent.validations.userRules.requireUser'),
          min: this.$t('message.loginComponent.validations.userRules.minCharacters', {min: '{length}'}),
          regex: this.$t('message.loginComponent.validations.userRules.charactersValidation')
        }
      }
    });
  },
  computed: {
    colorOutlineUser() {
      return errors =>
        errors
          ? 'danger'
          : this.loginCustomParamsFields.styles.form.inputs.outlineColor
    },
  },
  methods: {
    activeButton(event) {
      if (event.keyCode === 13) {
        event.preventDefault()
        this.$emit('activeButton')
      }
    },
    validateAutofill() {
      setTimeout(() => {
        let isAutofill =  document.querySelectorAll(':-webkit-autofill');
        if(isAutofill.length === 0) return
        let inputComponents = [ this.$refs.ztInputUser, this.$refs.ztInputPass]
        let elms =  document.querySelectorAll('.zt-input-main')
        for (let i = 0; i < elms.length; ++i) {
          let inputLabel = elms[i].querySelectorAll('label')[0]
          inputLabel.classList.add('zt-label-active')
          let inputLegend =  elms[i].querySelectorAll('legend')[0]
          inputLegend.style.width = `${inputComponents[i].labelWidth}px`
        }
      }, 500)
    }
  },
  mounted() {
    this.validateAutofill();
  }
}
</script>

<style scoped></style>
